// import axios from "axios";

import ApiService from "./api.service";

// const api = axios.create({
//   baseURL: "http://127.0.0.1:8000/api",
//   headers: {
//     "Content-Type": "application/json",
//   },
// });
const adminUrl = "/ai/admin/documents"

export const askQuestion = (question) => {
    console.log("askQuestion called with question:", question);
    return ApiService.post("/ai/ask", {
        "question": question
    });
};


// Route::get('/documents', [AIDocumentController::class, 'index']);
export const getDocuments = () => {
    return ApiService.get(adminUrl);
}

// Route::get('/documents/{id}', [AIDocumentController::class, 'show']);
export const getDocumentById = (id) => {
    return ApiService.get(`${adminUrl}/${id}`);
}

// Route::delete('/documents/{id}', [AIDocumentController::class, 'destroy']);
export const deleteDocumentById = (id) => {
    return ApiService.delete(`${adminUrl}/${id}`);
}

// export const getDocumentChunks = (document_id) => {
//     return ApiService.get(`${adminUrl}/${document_id}/chunks`);
// }

// export const deleteDocumentChunk = (id) => {
//     return ApiService.delete(`/admin/document-chunks/${id}`);
// }

// Route::post('/documents/{id}/reindex', [AIDocumentController::class, 'reindex']);
export const reindexDocument = (document_id) => {
    return ApiService.post(`${adminUrl}/${document_id}/reindex`);
}

export function uploadDocument(title, file, type) {
    console.log(type)
    const formData = new FormData();
    formData.append("title", title);
    formData.append("file", file);
    formData.append("type", type); // ✅ REQUIRED

    return ApiService.post("/ai/documents/upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}